export default "__VITE_ASSET__CgO0$TGC__"